import { Injectable } from '@angular/core';
import {ConfigurationDataProvider} from '../configuration-data-provider';
import {SharedDataProvider} from '../shared-data-provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {LocationSearchRequest} from '../dto/location';

@Injectable()
export class LocationSearchProvider {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataProvider, private shared: SharedDataProvider) {
  }

  /**
   * Search all locations which belong to loggedin user.
   */
  public searchLocation(request: LocationSearchRequest) {
    request.credentials = this.shared.getTokenAuthData();
    console.log("Call: "+ this.config.locationSearchURL + "lss data: " + JSON.stringify(request));
    return this.http.post(this.config.locationSearchURL+"lss", JSON.stringify(request), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// ./src/providers/location-search/location-search.ts